import React, { useEffect, useState } from 'react'
import PipeColumn from './PipeColumn'
import axios from 'axios';
import '../../css/pipeline.css'
import {  useNavigate } from 'react-router-dom';
import { DndContext, DragOverlay, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';

export default function PipeContainer(props) {

   const navigate = useNavigate();
   const [data,setData] =  useState([]);
   const [satatus, setSatatus] = useState('wait');
   const [pendingCardId, setPendingCardId] = useState(null);
   const [activeDrag, setActiveDrag] = useState(null);

   const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 8 } }));

    const onRefresh = () => {
      props.onRefreshHundler();
    }

   useEffect(()=>{
    if(!props.url) {
      return;
    }
      setSatatus('wait');
      axios.get(props.url, { withCredentials: true })
      .then(response => {
        setData(response.data);
        setSatatus('none');
      })
      .catch(err => {
        setSatatus('error');
        console.log(err);
      });
   },[props.url, props.refresh])

   const handleDragStart = ({active}) => {
      setActiveDrag(active.data.current);
   }

   const handleDragEnd = ({active, over}) => {
      setActiveDrag(null);
      const dragData = active.data.current;
      if(!over || !dragData || over.id === dragData.fromStageId) {
         return;
      }
      setPendingCardId(dragData.clientId);
      axios.put('/api/clients/'+dragData.clientId,
         JSON.stringify({stage: over.id}), {
            withCredentials: true,
            headers: { 'Content-Type': 'application/json' },
      }).then(() => {
         onRefresh();
      }).catch(err => {
         console.log(err);
      }).finally(() => {
         setPendingCardId(null);
      });
   }

  return (
    <DndContext sensors={sensors} onDragStart={handleDragStart} onDragEnd={handleDragEnd}>
    <div className='pipe-container'>
      { satatus === 'wait' && data.length === 0 ? (
               <div className='pipe-loader'></div>
            ) : data && Array.isArray(data) && data.length > 0? (
               data.map(item => (

                  <PipeColumn stages={data} stateHundler={props.stateHundler}  conversationId={props.conversationId}
                  key={item.id} id={item.id} title={item.name} color={item.color}
                  nameFilter={props.nameFilter} pendingCardId={pendingCardId}
                  onRefresh={onRefresh} refresh={props.refresh} url='/api/clients'></PipeColumn>

               ))
            ) : (
               <div></div>
         )}
    </div>
    <DragOverlay>
       {activeDrag ? (
          <div className='pipe-card pipe-card-overlay' style={{borderLeft:`3px solid ${activeDrag.color}`}}>
             <h4 className='pipe-card-title'>{activeDrag.client.firstName} {activeDrag.client.lastName}</h4>
          </div>
       ) : null}
    </DragOverlay>
    </DndContext>
  )
}
